import provideDataHook from '~/helpers/provideDataHook';
import {
  CarBrandAndCategory,
  getDataHook
} from '~/App/views/CarTreeAndCategory/CarBrandAndCategory';

export default provideDataHook(
  'MachinesCategory',
  getDataHook({ mainCategory: 'machines' })
)(CarBrandAndCategory);
